module.exports = __webpack_public_path__ + "img/Northern Cyprus.b203474d.svg";